import React, { useEffect, useRef, useState } from 'react'
import Layout from '../../../components/Layout'
import OutgoingPayment from '../OutgoingPayment'
import { ClipLoader } from 'react-spinners'
import Button from '../../../components/Button'
import { useSelector } from 'react-redux'
import api from '../../../api'
import { CheckIcon } from 'lucide-react'
import { ErrorModal, SuccessModal } from '../../../components/Modal'
import { useNavigate } from 'react-router-dom'
import { get } from 'lodash'
import { removeSpaces } from '../../../utils/removeSpaces'
import { BG_COLOR } from '../../../constants/colors'

export default function ReceivedJournalEntries() {
	const today = new Date().toISOString().split('T')[0]
	const { getMe } = useSelector((state) => state.main)
	const navigate = useNavigate()
	const successModalRef = useRef()
	const errorRef = useRef()

	const [isSubmitting, setIsSubmitting] = useState(false)
	const [data, setData] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [skip, setSkip] = useState(0)
	const [startDate, setStartDate] = useState(today)
	const [endDate, setEndDate] = useState(today)

	useEffect(() => {
		;(async () => {
			setIsLoading(true)
			try {
				const response = await api.get('/DraftJournalEntry', {
					params: {
						$filter: `U_Receiver eq ${getMe?.EmployeeID} and CreateDate ge '${startDate}T00:00:00Z' and CreateDate le '${endDate}T23:59:59Z'`,
						$select: 'U_Sender,U_Receiver,CreateDate,JOURNALENTRYRCollection',
						$skip: skip,
						$top: 20,
					},
					headers: {
						Prefer: 'odata.maxpagesize=100000',
					},
				})
				const resData = JSON.parse(response.data).value

				const updatedData = resData.map((item) => ({
					...item,
					received:
						item.JOURNALENTRYRCollection[0].U_Sent === 'Yes' &&
						item.JOURNALENTRYRCollection[0].U_Received === 'Yes',
				}))

				setData(updatedData)
			} catch (error) {
				console.log(error)
			} finally {
				setIsLoading(false)
			}
		})()
	}, [startDate, endDate, getMe?.EmployeeID, skip])

	const handleReceive = async (item) => {
		const docEntry = item.JOURNALENTRYRCollection[0].DocEntry
		setIsSubmitting(true)
		try {
			const currency = item.JOURNALENTRYRCollection[0].U_Currency
			const paidSum = item.JOURNALENTRYRCollection[0].U_PaidSum
			console.log('paidSum', paidSum)

			const PostData = {
				ReferenceDate: item.JOURNALENTRYRCollection[0].U_Date,
				U_DocNum: 'Journal',
				Memo: item.JOURNALENTRYRCollection[0].U_Comment || '',
				U_Creator: item.JOURNALENTRYRCollection[0].U_Sender,
				JournalEntryLines: [
					{
						AccountCode: item.JOURNALENTRYRCollection[0].U_ToAccount,
						Debit: currency === 'USD' ? removeSpaces(paidSum) : 0,
						Credit: 0,
						FCDebit: currency === 'UZS' ? removeSpaces(paidSum) : 0,
						FCCredit: 0,
						FCCurrency: currency === 'UZS' ? currency : '',
						ContraAccount: item.JOURNALENTRYRCollection[0].U_FromAccount,
					},
					{
						AccountCode: item.JOURNALENTRYRCollection[0].U_FromAccount,
						Debit: 0,
						Credit: currency === 'USD' ? removeSpaces(paidSum) : 0,
						FCDebit: 0,
						FCCredit: currency === 'UZS' ? removeSpaces(paidSum) : 0,
						FCCurrency: currency === 'UZS' ? currency : '',
						ContraAccount: item.JOURNALENTRYRCollection[0].U_ToAccount,
					},
				],
			}
			console.log(PostData)

			await api.post('JournalEntries', PostData).then(async () => {
				await api
					.patch(`/DraftJournalEntry(${docEntry})`, {
						JOURNALENTRYRCollection: [{ LineId: 1, U_Received: 'Yes' }],
					})
					.then(() => {
						setData((prevData) =>
							prevData.map((dataItem) =>
								dataItem.DocEntry === docEntry
									? { ...dataItem, received: true }
									: dataItem,
							),
						)
					})
			})

			successModalRef.current?.open('Бугалтерский операция успешно создана!')
		} catch (error) {
			errorRef.current?.open(
				get(JSON.parse(error.response.data), 'error.message', ''),
			)
		} finally {
			setIsSubmitting(false)
		}
	}

	return (
		<Layout>
			<OutgoingPayment
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<p className="productTitle">Принят деньги на кассу</p>
					<div className="flex flex-row items-center justify-between my-4">
						<div className="flex flex-row gap-4 justify-start items-center">
							<div className="flex flex-col">
								<span className="text-sm text-gray-500 mb-2">Дата начала</span>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									value={startDate}
									onChange={(e) => setStartDate(e.target.value)}
								/>
							</div>
							<div className="flex flex-col">
								<span className="text-sm text-gray-500 mb-2">
									Дата окончания
								</span>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									value={endDate}
									onChange={(e) => setEndDate(e.target.value)}
								/>
							</div>
						</div>
					</div>
					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
								<tr>
									<th scope="col" className="px-6 py-4">
										Дата
									</th>
									<th scope="col" className="px-6 py-4">
										C кассы
									</th>
									<th scope="col" className="px-6 py-4">
										На сейф
									</th>
									<th scope="col" className="px-6 py-4">
										Сумма
									</th>
									<th scope="col" className="px-6 py-4">
										Валюта
									</th>
									<th scope="col" className="px-6 py-4">
										Комментарий
									</th>
									<th scope="col" className="px-6 py-4">
										Статус подтверждения
									</th>
									<th scope="col" className="px-6 py-4">
										Подтверждение
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => {
									const isReceived = item.received // Check if the item is marked as received

									return (
										<tr
											className="bg-white border-b  hover:bg-gray-50 "
											key={index}
										>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_Date.split('T')[0]}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_FromAccount}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_ToAccount}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_PaidSum}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_Currency}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_Comment || '—'}
											</td>
											<td className="px-6 py-4">
												<span>
													{item.JOURNALENTRYRCollection[0].U_Sent === 'Yes' &&
													item.JOURNALENTRYRCollection[0].U_Received === 'Yes'
														? 'Да'
														: 'Нет'}
												</span>{' '}
											</td>
											<td className="px-6 py-4">
												<div className="flex flex-row gap-2 items-center">
													{isReceived ? null : (
														<Button
															className="bg-green-400 text-white rounded-md size-4"
															btnStyle={{
																width: 20,
																height: 20,
															}}
															disabled={isSubmitting}
															isLoading={isSubmitting}
															onClick={() => handleReceive(item)}
														>
															{isSubmitting ? null : <CheckIcon />}
														</Button>
													)}
												</div>
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					)}
					<div className="topCard">
						<div style={{ alignItems: 'center' }} className="flex">
							<Button
								onClick={() => {
									if (skip > 0) {
										setSkip(skip - 20)
									}
								}}
								btnStyle={{ marginRight: 10 }}
								disabled={skip === 0}
							>
								{'<'}
							</Button>
							<p style={{ marginRight: '10px' }}>
								{Math.ceil((skip + 1) / 20)}
							</p>
							<Button
								onClick={() => {
									if (data.length === 20) {
										setSkip(skip + 20)
									}
								}}
								disabled={data.length < 20}
							>
								{'>'}
							</Button>
						</div>
					</div>
				</div>
			</OutgoingPayment>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<SuccessModal
				getRef={(r) => {
					successModalRef.current = r
				}}
				onConfirm={() => {
					window.location.reload()

					// navigate('/received-draft-journal-entries')
				}}
			/>
		</Layout>
	)
}
